import { render } from "./DataBlendAggregations.vue?vue&type=template&id=76826f92"
import script from "./DataBlendAggregations.vue?vue&type=script&lang=js"
export * from "./DataBlendAggregations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/DataBlendAggregations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76826f92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76826f92', __exports__)) {
    api.reload('76826f92', __exports__)
  }
  
  module.hot.accept("./DataBlendAggregations.vue?vue&type=template&id=76826f92", () => {
    api.rerender('76826f92', render)
  })

}


export default __exports__